import { render } from "./ListAddressModal.vue?vue&type=template&id=206f0cda&scoped=true"
import script from "./ListAddressModal.vue?vue&type=script&lang=js"
export * from "./ListAddressModal.vue?vue&type=script&lang=js"

import "./ListAddressModal.vue?vue&type=style&index=0&id=206f0cda&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206f0cda"]])

export default __exports__